import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppMessage } from 'src/app/models/app-message';
import { ZbResponseStatusCodes } from 'src/app/models/zb-response';
import { MainAppService } from 'src/app/services/main-app.service';

@Component({
  selector: 'app-app-messages-detail',
  templateUrl: './app-messages-detail.component.html',
  styleUrls: ['./app-messages-detail.component.css']
})
export class AppMessagesDetailComponent implements OnInit {

  public data:AppMessage;

  constructor(
    public mainAppService: MainAppService,
    public dialogRef: MatDialogRef<AppMessagesDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: AppMessage) {
      this.data = _data;
    }

  ngOnInit(): void {
  }

  save(){
    this.mainAppService.updateAppMessage(this.data).subscribe(result =>{
      if (result && result.responseData &&  result.statusCode == ZbResponseStatusCodes.OK ){
        this.dialogRef.close(true);
      }
    })
  }
}
